import {
  ERROR_CLEARED,
  MESSAGE_CLEARED,
  ADD_MESSAGE,
  WAIT,
  UNWAIT,
} from "../actions/uiActions";

import {
  REGISTRATION_RESPONSE,
} from "../actions/registrationActions";

import {
  UNKNOWN_ERROR,
  SCHEMA_ERROR,
  ADD_ERROR,
} from "../actions/errorActions";
import { LOGIN_RESPONSE } from "../actions/loginActions";
import { LOG_OUT_USER } from "../actions/globalActions";
import initialState from "../state/initialState";
import produce from "immer";

export default function ui(state = {}, action) {
  switch (action.type) {
    case WAIT:
      return waitingReduction(state);
    case SCHEMA_ERROR:
    case UNKNOWN_ERROR:
    case ADD_ERROR:
      return errorReduction(action, state);
    case ERROR_CLEARED:
      return clearErrorReduction(state);
    case MESSAGE_CLEARED:
      return clearMessageReduction(state);
    case REGISTRATION_RESPONSE:
    case LOGIN_RESPONSE:
    case UNWAIT:
      return unWait(state, action);
    case ADD_MESSAGE:
      return addMessageReduction(state, action);
    case LOG_OUT_USER:
      return logOutUserReduction();
    default:
      return state;
  }
}

function waitingReduction(state) {
  return produce(state, (draft) => {
    draft.waiting = true;
  });
}

function errorReduction(action, state) {
  return produce(state, (draft) => {
    const { error } = action;
    const errorMessage = error?.message ?? error;
    draft.errorReceived = true;
    draft.errorMessage = errorMessage;
    draft.waiting = false;
  });
}

function clearErrorReduction(state) {
  return produce(state, (draft) => {
    draft.errorReceived = false;
    draft.errorMessage = "";
  });
}

function addMessageReduction(state, action) {
  return produce(state, (draft) => {
    draft.messageReceived = true;
    draft.message = action.message;
  });
}

function clearMessageReduction(state) {
  return produce(state, (draft) => {
    draft.messageReceived = false;
    draft.message = "";
  });
}

function unWait(state, action) {
  return produce(state, (draft) => {
    draft.waiting = false;
  });
}

function logOutUserReduction() {
  return initialState.ui;
}
